import { deleteRequest, get, publicPost, put } from "../helpers/apihelpers";

export const CreateWatiService=async(data)=>{
    try {
        const result = await publicPost(`api/wati/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateWatiService=async(data,id)=>{
    try {
        const result = await put(`api/wati/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetWatiService=async(page,from_date,to_date)=>{
    try {
        const result = await get(`api/wati/get?page=${page}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteWatiService=async(id)=>{
    try {
        const result = await deleteRequest(`api/wati/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetWelcomeMessageListService=async(page,from_date,to_date,status)=>{
    try {
        const result = await get(`api/promotional/get_inital_message?page=${page}&from_date=${from_date}&to_date=${to_date}&status=${status}`);
        return result;
    } catch (err) {
        return err.response;
    }
}